/*!
 * Lightbox v2.11.5
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */

// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.lightbox = factory(root.jQuery);
    }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);

    this.plugins         = [];
    this.zoomEnabled     = false;
    this.zoomFactor      = 1.0;
    this.rotation        = 0;
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: 'Image %1 of %2',
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
    Sanitize Title
    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
    This will free you to add html tags, such as links, in the caption.

    If the caption data is user submitted or from some other untrusted source, then set this to true
    to prevent xss and other injection attacks.
     */
    sanitizeTitle: false
  };

  Lightbox.prototype.option = function(options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function(currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function() {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function() {
      self.construct();
    });

    document.addEventListener('livewire:navigated', () => {
      self.construct();
    });

    on('window', 'enable-lightbox', null, () => {
      self.construct();
    });
  };

  /**
   * Constructs the Lightbox instance.
   * Initializes properties and sets up the necessary configurations
   * for the lightbox functionality.
   *
   * @constructor
   */
  Lightbox.prototype.construct = function() {
    this.zoomEnabled     = false;
    this.zoomFactor      = 1.0;
    this.rotation        = 0;

    this.enable();
    this.build();
  }

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function() {
    var self = this;

    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
      const link = $(event.currentTarget);
      self.start(link);

      if (link.attr('data-plugins')) {
        self.plugins = link.attr('data-plugins').split(',');
        self.showPlugins()
        self.closeZoom();
      }

      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function() {
    if ($('#lightbox').length > 0) {
        return;
    }

    var self = this;

    // The two root notes generated, #lightboxOverlay and #lightbox are given
    // tabindex attrs so they are focusable. We attach our keyboard event
    // listeners to these two elements, and not the document. Clicking anywhere
    // while Lightbox is opened will keep the focus on or inside one of these
    // two elements.
    //
    // We do this so we can prevent propagation of the Esc keypress when
    // Lightbox is open. This prevents it from interfering with other components
    // on the page below.
    //
    // Github issue: https://github.com/lokesh/lightbox2/issues/663
    $('<div id="lightboxOverlay" tabindex="-1" class="lightboxOverlay"></div><div id="lightbox" tabindex="-1" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt=""/><div class="lb-nav"><a class="lb-prev" role="button" tabindex="0" aria-label="Previous image" href="" ></a><a class="lb-next" role="button" tabindex="0" aria-label="Next image" href="" ></a></div><div class="lb-loader"><a class="lb-cancel" role="button" tabindex="0"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close" role="button" tabindex="0"></a></div></div></div></div>').appendTo($('body'));

    // Cache jQuery objects
    this.$lightbox          = $('#lightbox');
    this.$overlay           = $('#lightboxOverlay');
    this.$outerContainer    = this.$lightbox.find('.lb-outerContainer');
    this.$container         = this.$lightbox.find('.lb-container');
    this.$image             = this.$lightbox.find('.lb-image');
    this.$nav               = this.$lightbox.find('.lb-nav');

    this.$controlPane       = null;
    this.$rotateRightButton = null;
    this.$rotateLeftButton  = null;
    this.$printButton       = null;
    this.$zoomButton        = null;
    this.$zoomContainer     = null;
    this.$zoomBox           = null;
    this.$zoomImage         = null;

    // Store css values for future lookup
    this.containerPadding = {
      top: parseInt(this.$container.css('padding-top'), 10),
      right: parseInt(this.$container.css('padding-right'), 10),
      bottom: parseInt(this.$container.css('padding-bottom'), 10),
      left: parseInt(this.$container.css('padding-left'), 10)
    };

    this.imageBorderWidth = {
      top: parseInt(this.$image.css('border-top-width'), 10),
      right: parseInt(this.$image.css('border-right-width'), 10),
      bottom: parseInt(this.$image.css('border-bottom-width'), 10),
      left: parseInt(this.$image.css('border-left-width'), 10)
    };

    // Attach event handlers to the newly minted DOM elements
    this.$overlay.hide().on('click', function() {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
    });

    this.$outerContainer.on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$lightbox.find('.lb-prev').on('click', function() {
      if (self.currentImageIndex === 0) {
        self.changeImage(self.album.length - 1);
      } else {
        self.changeImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function() {
      if (self.currentImageIndex === self.album.length - 1) {
        self.changeImage(0);
      } else {
        self.changeImage(self.currentImageIndex + 1);
      }
      return false;
    });

    /*
      Show context menu for image on right-click

      There is a div containing the navigation that spans the entire image and lives above of it. If
      you right-click, you are right clicking this div and not the image. This prevents users from
      saving the image or using other context menu actions with the image.

      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
      we set the pointer events back to auto for the nav div so it can capture hover and left-click
      events as usual.
     */
    this.$nav.on('mousedown', function(event) {
      if (event.which === 3) {
        self.$nav.css('pointer-events', 'none');

        self.$lightbox.one('contextmenu', function() {
          setTimeout(function() {
              this.$nav.css('pointer-events', 'auto');
          }.bind(self), 0);
        });
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click keyup', function(e) {
      // If mouse click OR 'enter' or 'space' keypress, close LB
      if (
        e.type === 'click' || (e.type === 'keyup' && (e.which === 13 || e.which === 32))) {
        self.end();
        return false;
      }
    });

    self.initPlugins();
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function($link) {
    var self    = this;
    var $window = $(window);

    $window.on('resize', $.proxy(this.sizeOverlay, this));

    this.sizeOverlay();

    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        alt: $link.attr('data-alt'),
        link: $link.attr('href'),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }

    // Position Lightbox
    var top  = $window.scrollTop() + this.options.positionFromTop;
    var left = $window.scrollLeft();
    this.$lightbox.css({
      top: top + 'px',
      left: left + 'px'
    }).fadeIn(this.options.fadeDuration);

    // Disable scrolling of the page while open
    if (this.options.disableScrolling) {
      $('body').addClass('lb-disable-scrolling');
    }

    this.changeImage(imageNumber);
  };

  // Hide most UI elements in preparation for the animated resizing of the lightbox.
  Lightbox.prototype.changeImage = function(imageNumber) {
    var self = this;
    var filename = this.album[imageNumber].link;
    var filetype = filename.split('.').slice(-1)[0];
    var $image = this.$lightbox.find('.lb-image');

    // Disable keyboard nav during transitions
    this.disableKeyboardNav();

    // Show loading state
    this.$overlay.fadeIn(this.options.fadeDuration);
    $('.lb-loader').fadeIn('slow');
    this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();
    this.$outerContainer.addClass('animating');

    // When image to show is preloaded, we send the width and height to sizeContainer()
    var preloader = new Image();
    preloader.onload = function() {
      var $preloader;
      var imageHeight;
      var imageWidth;
      var maxImageHeight;
      var maxImageWidth;
      var windowHeight;
      var windowWidth;

      $image.attr({
        'alt': self.album[imageNumber].alt,
        'src': filename
      });

      // reset zoom plugin image
      self.$zoomImage.attr('src', filename);

      $preloader = $(preloader);

      var preloaderWidth = preloader.width;
      var preloaderHeight = preloader.height;

      if (self.rotation % 180 !== 0) {
        preloaderHeight = preloader.width;
        preloaderWidth = preloader.height;
      }

      $image.width(preloaderWidth);
      $image.height(preloaderHeight);

      var aspectRatio = preloader.width / preloader.height;

      windowWidth = $(window).width();
      windowHeight = $(window).height();

      // Calculate the max image dimensions for the current viewport.
      // Take into account the border around the image and an additional 10px gutter on each side.
      maxImageWidth  = windowWidth - self.containerPadding.left - self.containerPadding.right - self.imageBorderWidth.left - self.imageBorderWidth.right - 20;
      maxImageHeight = windowHeight - self.containerPadding.top - self.containerPadding.bottom - self.imageBorderWidth.top - self.imageBorderWidth.bottom - self.options.positionFromTop - 70;

      /*
      Since many SVGs have small intrinsic dimensions, but they support scaling
      up without quality loss because of their vector format, max out their
      size inside the viewport.
      */
      if (filetype === 'svg') {
        if (aspectRatio >= 1) {
          imageWidth = maxImageWidth;
          imageHeight = parseInt(maxImageWidth / aspectRatio, 10);
        } else {
          imageWidth = parseInt(maxImageHeight / aspectRatio, 10);
          imageHeight = maxImageHeight;
        }
      } else {

        // Fit image inside the viewport.
        if (self.options.fitImagesInViewport) {

          // Check if image size is larger than maxWidth|maxHeight in settings
          if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
            maxImageWidth = self.options.maxWidth;
          }
          if (self.options.maxHeight && self.options.maxHeight < maxImageHeight) {
            maxImageHeight = self.options.maxHeight;
          }

        } else {
          maxImageWidth = self.options.maxWidth || preloaderWidth || maxImageWidth;
          maxImageHeight = self.options.maxHeight || preloaderHeight || maxImageHeight;
        }

        // Is the current image's width or height is greater than the maxImageWidth or maxImageHeight
        // option than we need to size down while maintaining the aspect ratio.
        if ((preloaderWidth > maxImageWidth) || (preloaderHeight > maxImageHeight)) {
          if ((preloaderWidth / maxImageWidth) > (preloaderHeight / maxImageHeight)) {
            imageWidth  = maxImageWidth;
            imageHeight = parseInt(preloaderHeight / (preloaderWidth / imageWidth), 10);
          } else {
            imageHeight = maxImageHeight;
            imageWidth = parseInt(preloaderWidth / (preloaderHeight / imageHeight), 10);
          }
        }
      }

      self.rotateImage($image, imageWidth, imageHeight);
      self.sizeContainer(imageWidth, imageHeight);
    };

    // Preload image before showing
    preloader.src = this.album[imageNumber].link;
    this.currentImageIndex = imageNumber;
  };

  // Stretch overlay to fit the viewport
  Lightbox.prototype.sizeOverlay = function() {
    var self = this;
    /*
    We use a setTimeout 0 to pause JS execution and let the rendering catch-up.
    Why do this? If the `disableScrolling` option is set to true, a class is added to the body
    tag that disables scrolling and hides the scrollbar. We want to make sure the scrollbar is
    hidden before we measure the document width, as the presence of the scrollbar will affect the
    number.
    */
    setTimeout(function() {
      self.$overlay
        .width($(document).width())
        .height($(document).height());

    }, 0);
  };

  // Animate the size of the lightbox to fit the image we are showing
  // This method also shows the the image.
  Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
    var self = this;

    var oldWidth  = this.$outerContainer.outerWidth();
    var oldHeight = this.$outerContainer.outerHeight();
    var newWidth  = imageWidth + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right;
    var newHeight = imageHeight + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;

    function postResize() {
      self.$lightbox.find('.lb-dataContainer').width(newWidth);
      self.$lightbox.find('.lb-prevLink').height(newHeight);
      self.$lightbox.find('.lb-nextLink').height(newHeight);

      // Set focus on one of the two root nodes so keyboard events are captured.
      self.$overlay.trigger('focus');

      self.showImage();
    }

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      this.$outerContainer.animate({
        width: newWidth,
        height: newHeight
      }, this.options.resizeDuration, 'swing', function() {
        postResize();
      });
    } else {
      postResize();
    }
  };

  // Display the image and its details and begin preload neighboring images.
  Lightbox.prototype.showImage = function() {
    this.$lightbox.find('.lb-loader').stop(true).hide();
    this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration);

    this.updateNav();
    this.updateDetails();
    this.preloadNeighboringImages();
    this.enableKeyboardNav();
  };

  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function() {
    // Check to see if the browser supports touch events. If so, we take the conservative approach
    // and assume that mouse hover events are not supported and always show prev/next navigation
    // arrows in image sets.
    var alwaysShowNav = false;
    try {
      document.createEvent('TouchEvent');
      alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices) ? true : false;
    } catch (e) {}

    this.$lightbox.find('.lb-nav').show();

    if (this.album.length > 1) {
      if (this.options.wrapAround) {
        if (alwaysShowNav) {
          this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
        }
        this.$lightbox.find('.lb-prev, .lb-next').show();
      } else {
        if (this.currentImageIndex > 0) {
          this.$lightbox.find('.lb-prev').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev').css('opacity', '1');
          }
        }
        if (this.currentImageIndex < this.album.length - 1) {
          this.$lightbox.find('.lb-next').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-next').css('opacity', '1');
          }
        }
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function() {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      if (this.options.sanitizeTitle) {
        $caption.text(this.album[this.currentImageIndex].title);
      } else {
        $caption.html(this.album[this.currentImageIndex].title);
      }
      $caption.fadeIn('fast');
    }

    if (this.album.length > 1 && this.options.showImageNumberLabel) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }

    this.$outerContainer.removeClass('animating');

    this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
      return self.sizeOverlay();
    });
  };

  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function() {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  Lightbox.prototype.enableKeyboardNav = function() {
    this.$lightbox.on('keyup.keyboard', $.proxy(this.keyboardAction, this));
    this.$overlay.on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function() {
    this.$lightbox.off('.keyboard');
    this.$overlay.off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function(event) {
    var KEYCODE_ESC        = 27;
    var KEYCODE_LEFTARROW  = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    if (keycode === KEYCODE_ESC) {
      // Prevent bubbling so as to not affect other components on the page.
      event.stopPropagation();
      this.end();
    } else if (keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.changeImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(this.album.length - 1);
      }
    } else if (keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.changeImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(0);
      }
    }
  };

  Lightbox.prototype.initPlugins = function() {
    this.addPluginControlPane()
    this.addZoomPlugin();
    this.addPrintPlugin();
    this.addRotatePlugin();
  }

  Lightbox.prototype.showPlugins = function() {
    let self = this;

    const pluginButtonMap = [
      { plugin: 'rotate-right', button: this.$rotateRightButton },
      { plugin: 'rotate-left', button: this.$rotateLeftButton },
      { plugin: 'print', button: this.$printButton },
      { plugin: 'zoom', button: this.$zoomButton },
    ];

    pluginButtonMap.forEach(({ plugin, button }) => {
      button.css('display', self.plugins.includes(plugin) ? 'block' : 'none');
    });

    this.$controlPane.css('display', 'flex');
  }

  Lightbox.prototype.addPluginControlPane = function() {
    this.$controlPane = $(`<div class="plugin-control-pane"></div>`)
    this.$controlPane.css('display', 'none');
    this.$controlPane.appendTo(this.$container);
  }

  Lightbox.prototype.addZoomPlugin = function() {
    let self = this;
    self.zoomFactor = 1.0;

    this.$zoomButton = $('<button class="plugin-control lb-zoom"><i class="fa far fa-search"></i></button>')
      .css('display', 'none')
      .on('click', function (e) {
        if (self.zoomEnabled) {
          self.closeZoom();
        } else {
          self.openZoom();
          self.handleZoom(e.originalEvent.clientX, e.originalEvent.clientY)
        }
      });
    this.$controlPane.append(this.$zoomButton);

    this.$zoomContainer = $(`<div class="zoom-container"></div>`)
      .css('display', 'none')
      .on('mousemove', function (e) {
        self.handleZoom(e.originalEvent.clientX, e.originalEvent.clientY)
      })
      .on('wheel mousewheel DOMMouseScroll', function (e) {
        self.zoomFactor += (e.originalEvent.deltaY || 1) * -0.001;
        self.zoomFactor = Math.min(Math.max(1.0, self.zoomFactor), 6.0);

        self.handleZoom(e.originalEvent.clientX, e.originalEvent.clientY);
      });
    this.$zoomContainer.appendTo(this.$container);

    this.$zoomBox = $(`<div class="zoom-box"></div>`)
    this.$zoomBox.appendTo(this.$zoomContainer);

    this.$zoomImage = $(`<img id="zoomed-image" src="" alt="zoom">`)
    this.$zoomImage.appendTo(this.$zoomBox);
  }

  Lightbox.prototype.addPrintPlugin = function() {
    let self = this;

    if (this.$container) {
      this.$printButton = $('<button class="plugin-control lb-print"><i class="fa far fa-print"></i></button>')
        .css('display', 'none')
        .on('click', function () {
          let imgSrc = self.$image.attr('src');

          let $iframe = $('<iframe>', {
            css: {
              position: 'absolute',
              top: '-10000px',
              left: '-10000px'
            }
          }).appendTo('body');

          let iframeDoc = $iframe[0].contentWindow || $iframe[0].contentDocument;
          if (iframeDoc.document) iframeDoc = iframeDoc.document;

          iframeDoc.open();
          iframeDoc.write('<img src="' + imgSrc + '" style="width:100%;">');
          iframeDoc.close();

          // Fokussiere das iframe und starte den Druck
          $iframe[0].contentWindow.focus();
          $iframe[0].contentWindow.print();

          // Entferne das iframe nach dem Druckvorgang
          $iframe[0].contentWindow.onafterprint = function () {
            $iframe.remove();
          };
        });

      this.$controlPane.append(this.$printButton);
    }
  }

  Lightbox.prototype.addRotatePlugin = function() {
    let self = this;
    self.rotation = 0;

    if (this.$container) {
      this.$rotateRightButton = $('<button class="plugin-control lb-rotate-right"><i class="fa far fa-rotate-right"></i></button>')
        .css('display', 'none')
        .on('click', function () {
          self.rotation += 90;
          self.closeZoom()
          self.changeImage(self.currentImageIndex)
        });

      this.$controlPane.append(this.$rotateRightButton);

      this.$rotateLeftButton = $('<button class="plugin-control lb-rotate-left"><i class="fa far fa-rotate-left"></i></button>')
        .css('display', 'none')
        .on('click', function () {
          self.rotation -= 90;
          self.closeZoom()
          self.changeImage(self.currentImageIndex)
        });

      this.$controlPane.append(this.$rotateLeftButton);
    }
  }

  Lightbox.prototype.handleZoom = function(clientX, clientY) {
    if (!this.zoomEnabled) return;

    var self = this;

    const image = this.$container.children('img').first()[0];

    const rect = image.getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;

    // Vergrößerung des Bildes
    const zoomWidth = this.$image.width() * this.zoomFactor;
    const zoomHeight = this.$image.height() * this.zoomFactor;

    // Das Bild in der Zoom-Box vergrößern (beibehalten des Seitenverhältnisses)
    if (this.rotation % 180 === 0) {

      // Berechnung des Zoom-Ausschnitts im Bild
      const zoomX = Math.min((x / rect.width) * (zoomWidth - rect.width), zoomWidth);
      const zoomY = Math.min((y / rect.height) * (zoomHeight - rect.height), zoomHeight);

      this.$zoomImage.css({
        width: `${zoomWidth}px`,
        height: `${zoomHeight}px`,
        left: `-${zoomX}px`,
        top: `-${zoomY}px`,
        transform: `rotate(${this.rotation}deg)`
      });

    } else {

      let offsetW = (zoomHeight / 2) - (rect.width / 2);
      let offsetH = (zoomWidth / 2) - (rect.height / 2);
      let relW = (x - (rect.width / 2)) / (rect.width / 2);
      let relH = (y - (rect.height / 2)) / (rect.height / 2);
      let moveW = relW * offsetW;
      let moveH = relH * offsetH;

      let zoomX = Math.max(offsetW * -1, Math.min(offsetW, moveW));
      let zoomY = Math.max(offsetH * -1, Math.min(offsetH, moveH));

      if (this.rotation % 360 === 90) {
        zoomY *= -1;
      } else {
        zoomX *= -1;
      }

      this.$zoomImage.css({
        width: `${zoomWidth}px`,
        height: `${zoomHeight}px`,
        left: '50%',
        top: '50%',
        position: 'absolute',
        transform: `translate(-50%, -50%) rotate(${self.rotation}deg) translate(${zoomY}px, ${zoomX}px)`
      });
    }
  }

  Lightbox.prototype.openZoom = function() {
    this.zoomEnabled = true;

    if (this.$zoomContainer) {
      this.$zoomContainer.css('display', 'block');
    }

    if (this.$zoomButton) {
      this.$zoomButton.css('background-color', 'rgba(0, 255, 0, 0.5)');
    }
  }

  Lightbox.prototype.closeZoom = function() {
    this.zoomEnabled = false;

    if (this.$zoomContainer) {
      this.$zoomContainer.css('display', 'none');
    }

    if (this.$zoomButton) {
      this.$zoomButton.css('background-color', 'rgba(255, 255, 255, 0.8)');
    }
  }

  Lightbox.prototype.rotateImage = function(image, width, height) {
    var self = this;

    if (self.rotation % 180 !== 0) {
      // rotate the image again
      image.css({
        width: height,
        height: width,
        top: '50%',
        left: '50%',
        position: 'absolute',
        transform: `translate(-50%, -50%) rotate(${self.rotation}deg)`
      });
    } else {
      image.css({
        width: width,
        height: height,
        top: '4px',
        left: '4px',
        position: 'absolute',
        transform: `rotate(${self.rotation}deg)`
      });
    }
  }

  // Closing time. :-(
  Lightbox.prototype.end = function() {
    this.disableKeyboardNav();
    $(window).off('resize', this.sizeOverlay);
    this.$lightbox.fadeOut(this.options.fadeDuration);
    this.$overlay.fadeOut(this.options.fadeDuration);

    if (this.options.disableScrolling) {
      $('body').removeClass('lb-disable-scrolling');
    }
  };

  return new Lightbox();
}));
